export * from './text'
export const defaultPageSize = 30;
export const verificationTimeout = 60 * 5;

export const paginationRangeArray = ['10', '15', '20', '25', '30'];

export const default_timeslot_days_to_show = 3;

export const appVer = '2.0.4';